import { apiRequest, getToken } from "api";
import { BASE_URL } from "constants/routes";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { encryptPayload } from "./encrypt";

export const getConsent = createAsyncThunk(
  "consentReducer/getConsent",
  async ({ id, sub_id, organisation_id }) => {
    const req = `${BASE_URL}/organisation/getConsent`;
    let data = {
      _id: id,
      sub_id,
      organisation_id
    };
    let params = {
      body: {...data},
    };
    const encryptedBodyRes = await encryptPayload("", params, true, true);
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getToken()}`,
      },
      body: JSON.stringify(encryptedBodyRes),
    };
    const _options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    // console.log(data);

    try {
      const result = await encryptPayload(req, options, false, true,true);
      // const result = await encryptPayload(req, _options, false, false);
      // console.log({ result });
      return result.data;
    } catch (err) {
      console.log(err);
    }
  }
);
